import * as React from 'react';
import Viewer from 'react-viewer';
//import Button from '@material-ui/core/Button';

//import 'react-viewer/dist/index.css';

import CONFIG from '../../cfg/config';

import { AppState, IPageState } from '../../appredux';

import { connect } from 'react-redux';
import { fotoService } from '../../api';

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import './gallery.css'
import { Button, withStyles, Theme, WithStyles } from '@material-ui/core';

export interface GalleryProps extends  WithStyles<typeof styles>{
  room: string,
  className: string,
  icon?: string,
  button?: boolean,
  title: string,
  page: IPageState,
  visible: boolean,
  close: () => void
}

type TImage = {
  src: string;
  alt: string;
  downloadUrl: string
}

type GalleryState = {
  //visible : boolean;
  room: string;
  images: TImage[]
  selected: string,
  index: number,
}

class Gallery extends React.Component<GalleryProps, GalleryState> {
  //  container: HTMLDivElement;

  static defaultProps = {
    room: '',
    className: 'btn',
    icon: 'icon-picture',
    button: true,
    title: '',
  };

  constructor(props: GalleryProps) {
    super(props, {});

    //    this.container = null;

    this.state = {
      //visible: false,
      room: '',
      images: [],
      selected: '',
      index: 0,
    };
  }

  prepare(gal: any) {
    //let images: TImage[] = [];
    //console.log(gal)
    let images: any[] = [];
    if (gal)
      for (const g of gal) {
        images.push({
          src: g.url,
          //alt: g.alias,
          //downloadUrl: ''
        });
      }
    //console.log(images)
    this.setState({ room: this.props.room, images: images })
  }

  //PM 2021-07-05
  async getGallery() {
    fotoService.getGallery({
      hotelId: CONFIG.hotelID,
      rodzPokoi: this.props.room
      //katalog : this.props.room 
    }, {})
      .then(
        (res: any) => {
          //          alert(JSON.stringify(res));
          if(res.length === 0) this.props.close()
          else this.prepare(res)
        }
      )
      .catch((err: any) => {
        console.error(err)
      }
      );
  }

  /*
    shouldComponentUpdate(nextProps: GalleryProps, nextState : any) {
      if (nextProps.room != this.props.room)  {
        alert('!!!')
        this.getGallery();
        return true
      }
      else return false;
    }  
  */
  componentDidUpdate(prevProps: GalleryProps) {
    if (this.props.visible !== prevProps.visible){
      this.setState({index: 0})
      this.open();
    }
      
  }
  open() {
    if (this.props.visible && this.state.room != this.props.room) {
      this.getGallery()
    }
  }

  nextFoto = (n: number) => {
    let images = this.state.images
    let length = this.state.images.length
    let index = 0

    if (this.state.index + n >= length) {
        index = 0
    } else if (this.state.index + n < 0) {
        index = length - 1
    } else {
        index = this.state.index + n
    }

    this.setState({ selected: images[index].src, index: index })
}

change = (src: any, index: number) => {

    this.setState({ selected: src.src, index: index })
}

// toolbar = (toolbars: ToolbarConfig[]) => {
   
//         return [
//             { key: "prev", render: <ForwardIcon style={{ width: "0.8em", marginTop: "2px", marginRight: "1px", transform: "rotate(180deg)" }}></ForwardIcon>, onClick: () => { this.nextFoto(-1) } },
//             { key: "next", render: <ForwardIcon style={{ width: "0.8em", marginTop: "2px", marginRight: "-1px" }}></ForwardIcon>, onClick: () => { this.nextFoto(1) } },
//         ];
  
// }

//   toolbar = (toolbars: ToolbarConfig[]) => {
//     return [
//         { key: "prev", actionType: 3 },
//         { key: "next", actionType: 4 },
//         { key: "zoomIn", actionType: 1 },
//         { key: "zoomOut", actionType: 2 },
//         { key: "reset", actionType: 7 },
//     ];
// }

  render() {
    const { classes } = this.props;
    //         container={inline ? null : null}
    //if (this.props.button) {
    return (
      // <Button variant="outlined" color="primary"
      //         style={{ textTransform: 'none', height: "auto",
      //         padding: "6px 8px 5px 8px", lineHeight: "13px", 
      //         fontSize: "11px", marginLeft: "8px"
      //         }}
      // onClick={ 
      //   () => { this.switchVisible( !this.state.visible ); }
      //  }>
      // { this.props.title }
      <>
        {this.state.images.length > 0 && this.props.visible ?
          <div style={{}}>
            <div className={classes.transparentButton} style={{ left: "0%" }}
              onClick={() => { this.nextFoto(-1) }}>
              <Button
                className={classes.button}
                style={{ left: window.innerWidth < 600 ? "30%" : "50%" }}
                onClick={() => { }}>
                <ArrowBackIosNewIcon style={{ width: "1.3em", height: "1.3em", marginLeft: "-3px", color: "white" }} />
              </Button>
            </div>
            <div className={classes.transparentButton} style={{ right: "0%", }}
              onClick={() => { this.nextFoto(1) }}>
              <Button
                className={classes.button}
                style={{ right: window.innerWidth < 600 ? "10%" : "50%" }}
                onClick={() => { }}>
                <ArrowForwardIosIcon style={{ width: "1.3em", height: "1.3em", marginLeft: "3px", color: "white" }} />
              </Button>
            </div>
          </div> : null}

        {this.state.images.length > 0 ?
          <Viewer
            visible={this.props.visible}
            onClose={() => this.props.close()}
            images={this.state.images}
            //customToolbar={this.toolbar}
            //downloadable

            //zoomable={false}
            rotatable={false}
            scalable={false}
            //changeable={false}

            loop
            activeIndex={this.state.index}

            noToolbar
            //customToolbar={this.toolbar}
            onChange={this.change}
          />
          : null}
      </>
      // </Button>  
    )
    // }
    // else
    //     return (
    // <a href="#" className={ this.props.className } 
    //    style= {{ }}
    //    onClick={ 
    //      () => { this.switchVisible( !this.state.visible ); }
    //     }>
    //   <i className={ this.props.icon }></i>
    //   { this.props.title}
    // <Viewer
    //     visible={this.props.visible}
    //     onClose={() => this.props.close()}
    //     images={this.state.images}
    //     downloadable
    // />
    // </a>
    //);
  }
}

const styles = (theme: Theme) => ({
  transparentButton: {
    zIndex: 9999 , 
    position: "fixed" as "fixed", 
    top: "10%", 
    height: "80%", 
    width: "20%", 
    minWidth: "150px", 
    cursor: "pointer",
   "-webkit-tap-highlight-color": "transparent"
  },
  button: {
   backgroundColor: "rgba(0 0 0 / 0.2)",
   width: "60px", 
   height: "60px", 
   borderRadius: "60px", 
   minWidth: "50px", 
   margin: '-30px 0 0 -30px',
   position: "absolute" as "absolute", 
   top: '42%', 
   //left: '50%'
   "&:hover": {
       backgroundColor: "rgba(0 0 0 / 0.7)",
   }
  }
  
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});


export default connect(mapStateToProps)(withStyles(styles)(Gallery));